import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const {activePM, activePMSuccess, activePMbyIdSuccess} = isOfflineDev ? await import("../tests/fixtures/Preventative/activeWorkOrders.js") : {};
const {activeCM} = isOfflineDev ? await import("../tests/fixtures/Corrective/activeWorkOrders.js") : {};
const {proceduresSuccess} = isOfflineDev ? await import("../tests/fixtures/procedures.js") : {};
const {tasksSuccess} = isOfflineDev ? await import("../tests/fixtures/tasks.js") : {};

export async function getMixedWorkOrdersQuery(query, headers) {
  if (!isOfflineDev) {
    let url = BACKEND_API_PLACEHOLDER + '/api/preventative/mixed_query?'
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return {
    status: 200,
    data: { results: [...activePM, ...activeCM] }
  }
}

export async function getPreventiveQuery(query, headers) {
  if (!isOfflineDev) {
    let url = BACKEND_API_PLACEHOLDER + '/api/preventative/query?'
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return activePMSuccess
}

export async function putWorkOrderUpdate(id, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/work_order?id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getTasks(id, headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/tasks?work_order_id=${id}`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
      .catch(() => { return res })
    )
  }
  else return tasksSuccess
}

export async function getPreventiveSchedulesQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/preventative/schedules/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getPreventiveScheduleById(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + `/api/preventative/schedules/id?id=${id}`
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getExistingScheduleConfigs(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/preventative/configs', {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getScheduledTabInfo(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/config/pms/scheduled?schedule_id=${id}`, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getActiveTabInfo(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/config/pms/active?schedule_id=${id}`, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getCompletedTabInfo(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/config/pms/completed?schedule_id=${id}`, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function generateSchedule(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/preventative/schedule_generator', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getAllProcedures(headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + '/api/preventative/procedures/all', {
      method: 'GET',
      headers: headers,
    })
    .then(res => res.json()
    .then(data => { return data })
    )
  }
  else return proceduresSuccess
}

export async function getProceduresQuery(query, headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    let url = BACKEND_API_PLACEHOLDER + '/api/preventative/procedures/query?'
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
    .then(res => res.json()
    .then(data => { return data })
    )
  }
  else return proceduresSuccess
}

export async function postCreateSchedule(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/preventative/create_schedule', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function putEditSchedule(id, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/schedules/id?id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getProcedureDef(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/procedure/id?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

//deprecated?
export async function getVerifyLaborStatus(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/${id}/verify_labor_status`, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

//deprecated?
export async function getTasksStatus(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/${id}/fetch_tasks_status`, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function putUpdateTasks(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/update_tasks`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

//deprecated?
export async function postUpdateOwner(id, postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/${id}/update_owner`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getPMStageCheck(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/stage_check`, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function postPMBatchFetch(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/batch_fetch`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getPMWorkOrder(id, headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/id?id=${id}`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
      .catch(() => { return res })
    )
  }
  else return activePMbyIdSuccess
}

export async function postGenerateNewWorkOrderWithDates(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/generate_with_dates`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function advancePreventiveWorkOrder(workOrderId, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/preventative/advance/single?work_order_id=${workOrderId}`, {
    method: 'POST',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}
